'use client';

import { createContext, useContext, useState, ReactNode } from 'react';

type RightPanelContent = 'appointments' | 'diagnostics' | 'admin-appointments' | null;

interface RightPanelContextType {
  isOpen: boolean;
  content: RightPanelContent;
  openPanel: (content: RightPanelContent) => void;
  closePanel: () => void;
}

const RightPanelContext = createContext<RightPanelContextType | undefined>(undefined);

export function RightPanelProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<RightPanelContent>(null);

  const openPanel = (newContent: RightPanelContent) => {
    setContent(newContent);
    setIsOpen(true);
  };

  const closePanel = () => {
    setIsOpen(false);
    // Clear content after animation
    setTimeout(() => {
      setContent(null);
    }, 300);
  };

  return (
    <RightPanelContext.Provider value={{ isOpen, content, openPanel, closePanel }}>
      {children}
    </RightPanelContext.Provider>
  );
}

export function useRightPanel() {
  const context = useContext(RightPanelContext);
  if (context === undefined) {
    throw new Error('useRightPanel must be used within a RightPanelProvider');
  }
  return context;
}

